var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "material" },
    [
      _c(
        "el-row",
        { attrs: { type: "flex" } },
        [
          _c("el-col", { staticClass: "table-th", attrs: { span: 4 } }, [
            _vm._v("活动明细名称"),
          ]),
          _c(
            "el-col",
            { attrs: { span: 20 } },
            [
              _c(
                "el-row",
                { attrs: { type: "flex" } },
                [
                  _c(
                    "el-col",
                    { staticClass: "table-th", attrs: { span: 4 } },
                    [_vm._v("要求核销资料")]
                  ),
                  _c(
                    "el-col",
                    { staticClass: "table-th", attrs: { span: 7 } },
                    [_vm._v("描述")]
                  ),
                  _c(
                    "el-col",
                    { staticClass: "table-th", attrs: { span: 6 } },
                    [_vm._v("示例")]
                  ),
                  _c(
                    "el-col",
                    { staticClass: "table-th", attrs: { span: 7 } },
                    [_vm._v("上传")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._l(_vm.list, function (item, k) {
        return [
          item.auditRequires.length > 0
            ? _c(
                "el-row",
                { key: k, attrs: { type: "flex" } },
                [
                  _c(
                    "el-col",
                    { staticClass: "table-td", attrs: { span: 4 } },
                    [_vm._v(_vm._s(item.fineName))]
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    _vm._l(item.auditRequires, function (subItem, j) {
                      return _c(
                        "el-row",
                        { key: j, attrs: { type: "flex" } },
                        [
                          _c(
                            "el-col",
                            { staticClass: "table-td", attrs: { span: 4 } },
                            [_vm._v(_vm._s(subItem.exampleName))]
                          ),
                          _c(
                            "el-col",
                            { staticClass: "table-td", attrs: { span: 7 } },
                            [_vm._v(_vm._s(subItem.remarks))]
                          ),
                          _c(
                            "el-col",
                            { staticClass: "table-td", attrs: { span: 6 } },
                            [
                              _c(
                                "div",
                                [
                                  _c("el-image", {
                                    staticStyle: { "max-width": "80px" },
                                    attrs: {
                                      src: _vm.getImgUrls(
                                        subItem.pictureRespVos
                                      )[0],
                                      "preview-src-list": _vm.getImgUrls(
                                        subItem.pictureRespVos
                                      ),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "el-col",
                            { staticClass: "table-td", attrs: { span: 7 } },
                            [
                              _c(
                                "Upload",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.formConfig.disabled,
                                    astrictState: _vm.astrictState,
                                    fileMsg: "",
                                    clearable: "",
                                  },
                                  on: {
                                    getFileList: (v) =>
                                      _vm.getFileList(v, k, j),
                                  },
                                  model: {
                                    value: subItem.auditFileReqVos,
                                    callback: function ($$v) {
                                      _vm.$set(subItem, "auditFileReqVos", $$v)
                                    },
                                    expression: "subItem.auditFileReqVos",
                                  },
                                },
                                [_vm._v("上传")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }